import { cn } from '@growdash/design-system/utils/helpers.js';
import { Store } from 'lucide-react';

type Props = {
  src: string;
  className?: string;
  type?: 'food' | 'brand' | 'restaurant';
};

export default function GrowintelImage({
  src,
  className = '',
  type = 'food',
}: Props) {
  if (src) {
    return (
      <img
        className={`${className} rounded-lg object-cover object-center`}
        src={src}
        referrerPolicy="no-referrer"
        loading="lazy"
        onError={(e) => {
          e.currentTarget.style.display = 'none';
          e.currentTarget.parentElement
            ?.querySelector('.fallback-block')
            ?.classList.remove('hidden');
        }}
      />
    );
  } else {
    return (
      <div
        className={cn(
          ' w-16 h-16 bg-quarternary text-tertiary dark:text-quarternary flex items-center justify-center',
          className,
        )}
      >
        {type === 'food' && (
          <svg
            className="w-[70%] h-auto"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M12 16H4a2 2 0 1 1 0-4h16a2 2 0 1 1 0 4h-4.25" />
            <path d="M5 12a2 2 0 0 1-2-2 9 7 0 0 1 18 0 2 2 0 0 1-2 2" />
            <path d="M5 16a2 2 0 0 0-2 2 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 2 2 0 0 0-2-2q0 0 0 0" />
            <path d="m6.67 12 6.13 4.6a2 2 0 0 0 2.8-.4l3.15-4.2" />
          </svg>
        )}
        {type != 'food' && <Store className="w-[70%] h-auto" />}
      </div>
    );
  }
}
